module.exports = __webpack_public_path__ + "static/media/dino.15c1b9ec.gif";